import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

class ProgressPhotosView extends React.Component {
  render() {
    const { setModalOpen, openModal, photo } = this.props;

    return (
      <div>
        <Modal isOpen={openModal} className="photo-view-modal">
          <ModalHeader>
            <span className="modal-close" onClick={() => setModalOpen(false)}>
              <i className="fas fa-times"></i>
            </span>
          </ModalHeader>
          <ModalBody>
            <img src={photo} alt="Progress" />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ProgressPhotosView;
